import styled from '@emotion/styled';

export const MenuOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 16.75rem;
`;
